import { render, staticRenderFns } from "./gl-blockchain-icon.vue?vue&type=template&id=3518cf4b"
import script from "./gl-blockchain-icon.vue?vue&type=script&lang=js"
export * from "./gl-blockchain-icon.vue?vue&type=script&lang=js"
import style0 from "./gl-blockchain-icon.vue?vue&type=style&index=0&id=3518cf4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports